<template>
    <div class="ku-shop">
        <div class="top">
            <div class="left">
                <span>{{ address }}</span>
                <van-icon name="location" @click="userAddress" />
            </div>
            <div class="right">
                <van-field v-model="key" placeholder="搜索店铺" @keyup.enter="search" />
                <van-icon name="search" @click="search" />
            </div>
        </div>

        <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            finished-text="没有更多了"
            @load="onLoad"
        >
            <div class="ku-list" v-for="(item, index) in list" :key="index" @click="getShop(item)">
                <div class="list">
                    <div class="slide-item" v-for="(fv, fk) in item.food" :key="fk">
                        <van-image
                            fit="cover"
                            :src="fv.image"
                        />
                    </div>
                </div>
                <div class="logo">
                    <van-image
                        fit="cover"
                        :src="item.image"
                    />
                </div>
<!--                <div class="foot">{{ item.address }}</div>-->
                <div class="shop-name">{{ item.shop_name }}</div>
                <div class="zz" v-if="(coType === '1' && (!item.ts_time || item.ts_switch !== 1)) || (coType === '2' && (!item.wm_time || item.wm_switch !== 1))"></div>
                <div class="zz_sw" v-if="coType === '1' && item.ts_switch !== 1">

                </div>
                <div class="zz_sw" v-else-if="coType === '2' && item.wm_switch !== 1">

                </div>
                <div v-else>
                    <div class="zz_sj" v-if="(coType === '1' && !item.ts_time)">
                        <div>
                        <span>营业时间</span>
                        <span>{{ item.ts_start }} - {{ item.ts_end }}</span>
                        </div>
                    </div>
                    <div class="zz_sj" v-if="(coType === '2' && !item.wm_time)">
                        <div>
                        <span>配送时间</span>
                        <span>{{ item.wm_start }} - {{ item.wm_end }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </van-list>

        <van-popup v-model="show">
            <div class="pop-show">
<!--                <div class="s1">请仔细审核店铺地址</div>-->
                <div class="s2">请确认 当前下单店</div>
                <div class="s3">下单即做 无法退改</div>
                <div class="s4">
                    <span>{{ row.address }}</span>
                    <label>{{ row.shop_name }}</label>
                </div>
                <div class="s5">
                    <span @click="show = false">不是</span>
                    <span @click="goPush(row)">确定</span>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Field,Icon,List,Image as VanImage, Popup } from 'vant';
    import {getCookie, setCookie} from '@/utils/auth'
    import router from "@/router";

    Vue.use(Field).use(Icon).use(List).use(VanImage).use(Popup);
    export default {
        name: "index",
        data() {
            return {
                address: '',
                lat: '',
                lng: '',
                key: '',
                coType: 1,
                key_check: 1,

                list: [],
                loading: false,
                finished: false,
                page: 1,

                show: false,
                row: {}
            }
        },
        mounted() {
            this.address = getCookie('address')
            this.coType = getCookie('coType')
            this.key_check = getCookie('key_check')
            this.lat = getCookie('lat')
            this.lng = getCookie('lng')
            this.onLoad()
        },
        methods: {
            getShop(item) {
                if (this.coType === '1' && (!item.ts_time || item.ts_switch !== 1)) {
                    return false;
                }

                if (this.coType === '2' && (!item.wm_time || item.wm_switch !== 1)) {
                    return false;
                }

                // if (this.key_check === "0") {
                    this.row = item
                    this.show = true
                    // return false;
                // }
                // this.goPush(item)
            },
            goPush(item) {
                this.show = false
                setCookie('shop_id', item.id)
                this.$router.push({
                    path: item.check_time ? 'goods_fast' : '/goods',
                    query: {
                        shop_id: item.id
                    }
                })
            },
            search() {
                this.page = 1
                this.finished = false
                this.onLoad()
            },
            onLoad() {
                let that = this
                if (!that.finished) {
                    that.loading = true
                    if (that.page <= 1) {
                        that.list = []
                    }
                    this.$API.getShopList({
                        key: that.key,
                        page: that.page,
                        limit: 10,
                        s_address: {
                            lat: that.lat,
                            lng: that.lng
                        }
                    }).then(res => {
                        return res;
                    }).then(res => {
                        let data = res.data
                        that.loading = false;
                        if (parseInt(data.data.count) >= 1) {
                            data.data.list.forEach(function (item) {
                                that.list.push(item);
                            })
                        } else {
                            that.finished = true;
                        }
                        that.page = that.page+1
                    })
                }
            },
            userAddress() {
                let coType = getCookie('coType')
                if (coType === '2') {
                    router.push('/userAddress')
                } else {
                    setCookie('key_check', 2)
                    router.push('/address')
                }
            }
        },
    }
</script>

<style lang="less" scoped>
.ku-shop {
    .top {
        width: 99%;
        margin: 0 auto;
        .left {
            width: 49%;
            height: 50px;
            line-height: 50px;
            border: 1px solid #C29E7D;
            border-radius: 10px;
            padding: 0;
            position: relative;
            float: left;
            .van-icon {
                position: absolute;
                top: 8px;
                right: 0;
                font-size: 36px;
                color: #20AEA7;
            }
        }
        .right {
            width: 49%;
            height: 50px;
            line-height: 50px;
            border: 1px solid #C29E7D;
            border-radius: 10px;
            position: relative;
            float: right;
            .van-field {
                height: 50px;
                line-height: 50px;
                padding: 0 10px;
                background: none;
                border: none;
            }
            .van-icon {
                position: absolute;
                top: 8px;
                right: 8px;
                font-size: 36px;
                color: #20AEA7;
            }
        }
    }
    .ku-list {
        width: 240px;
        height: 382px;
        margin: 10px 3px;
        display: inline-block;
        float: left;
        border: 1px solid #EFEFEF;
        position: relative;
        .shop-assess {
            position: absolute;
            width: 32px;
            height: 32px;
            right: 24px;
            top: 13px;
            img {
                width: 32px;
                height: 32px;
            }
        }
        .shop-name {
            font-size: 24px;
            height: 50px;
            line-height: 50px;
            background: #BAA58C;
            color: white;
            width: 232px;
            margin: 0 auto;
        }
        .logo {
            width: 232px;
            height: 100px;
            margin: 0 auto;
            /deep/ .van-image__img {
                width: 232px;
                height: 100px;
            }
        }
        .list {
            width: 232px;
            height: 232px;
            margin: 0 auto;
            .slide-item {
                width: 232px;
                height: 232px;
                text-align: center;
                padding: 0;
                .van-image {
                    padding: 0;
                    margin: 0;
                    /deep/ .van-image__img {
                        width: 232px;
                        height: 232px;
                    }
                }
            }
        }
        .foot {
            width: 240px;
            height: 50px;
            line-height: 50px;
            overflow: hidden;
            font-size: 21px;
            font-family: 'Microsoft YaHei',serif;
            span {
                height: 45px;
                display: inline-block;
                position: relative;
                margin: 0 10px;
                &::after {
                    content: "";
                    width: 1px;
                    height: 25px;
                    position: absolute;
                    top: 10px;
                    left: -10px;
                    background: #E58059;
                }
                &::before {
                    content: "";
                    width: 1px;
                    height: 25px;
                    position: absolute;
                    top: 10px;
                    right: -10px;
                    background: #E58059;
                }
            }
        }
        .zz {
            position: absolute;
            width: 100%;
            height: 100%;
            background: #000;
            opacity: 0.5;
            left: 0;
            top: 0;
        }
        .zz_sw {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            background: url('../../assets/3.png') no-repeat center;
            background-size: 80%;
        }
        .zz_sj {
            position: absolute;
            width: 100%;
            height: 80px;
            left: 0;
            bottom: 150px;
            div {
                width: 80%;
                height: 80px;
                background: #fff;
                margin: 0 auto;
                border-radius: 10px;
                span {
                    display: block;
                    font-size: 28px;
                    line-height: 40px;
                    &:nth-child(2) {
                        color: #009C90;
                    }
                }
            }

        }
    }
    /deep/ .van-list__error-text, /deep/.van-list__finished-text, /deep/.van-list__loading {
        width: 100%;
        height: 50px;
        line-height: 50px;
        float: left;
    }
    .van-popup {
        background: none;
    }
    .pop-show {
        background: #50AFA7;
        width: 500px;
        height: 480px;
        font-family: "Microsoft YaHei",serif;
        border-radius: 30px;
        .s1 {
            width: 400px;
            height: 60px;
            line-height: 60px;
            font-size: 26px;
            color: #ffff00;
            background: #e45a24;
            border: 1px solid #ffff00;
            border-radius: 10px;
            margin: 30px auto 0 auto;
            display: inline-block;
        }
        .s2, .s3 {
            font-size: 32px;
            color: #fff;
        }
        .s2 {
            margin-top: 50px;
            display: inline-block;
        }
        .s3 {
            color: #ff0;
        }
        .s4 {
            width: 420px;
            height: 80px;
            padding: 40px 0;
            background: #fff;
            border-radius: 20px;
            margin: 20px auto 0 auto;
            span, label {
                display: block;
                line-height: 40px;
            }
            span {
                font-size: 38px;
                color: #f00;
            }
            label {
                font-size: 28px;
            }
        }
        .s5 {
            margin: 40px auto 0 auto;
            span {
                width: 120px;
                height: 70px;
                line-height: 70px;
                font-size: 26px;
                color: #fff;
                background: #006837;
                border-radius: 10px;
                display: inline-block;
                margin: 0 5px;
            }
        }
    }
}
</style>
